import { Fragment } from 'react'
import { IFlexLayout } from 'types'
import Layout from '..'
import { LayoutHelpers } from '../../../desktopTypes'
import { addLayoutTag } from '../../../utils/helpers'
import { parsePadding, useLayoutItems } from '../../../utils/layoutUtils'
import { SDivider, SView, SViewProps } from '../../scaled'
import EmptyLayout from '../EmptyLayout'

export default function FlexLayout({
  align,
  direction,
  playVideo,
  divider,
  gap = 8,
  justify,
  layouts,
  scroll,
  style,
  title,
  keyPath,
}: Omit<IFlexLayout, 'type'> & LayoutHelpers) {
  let childGrow = 0
  const items = useLayoutItems(
    layouts.map(({ basis, grow, ...rest }) => {
      if (grow) childGrow = grow
      return {
        ...rest,
        style: { basis, grow, shrink: scroll ? 0 : undefined },
      }
    }),
    keyPath
  )

  if (items.length === 0) return <EmptyLayout type="flex" />

  const padding = parsePadding({ style, title })
  const props: SViewProps = {
    align,
    justify,
    gap,
    direction,
    grow: style?.grow ?? childGrow,
    ...addLayoutTag('flex'),
    overflow: scroll ? 'auto' : 'hidden',
    ...padding,
  }

  return (
    <SView {...props}>
      {items.map(({ key, ...rest }, i) => (
        <Fragment key={i}>
          <Layout playVideo={playVideo} {...rest} />
          {divider && i < items.length - 1 && <SDivider vertical={direction === 'row'} />}
        </Fragment>
      ))}
    </SView>
  )
}
